export function isValidCatalogId(value?: string): boolean {
  if (value) {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(value);
  }
  return false;
}

export function isValidEmail(email?: string): boolean {
  if (!email) return false;
  
  // eslint-disable-next-line no-useless-escape
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  return emailRegex.test(email.trim());
}

export function isValidInstagram(instagram?: string): boolean {
  if (!instagram) {
    return true;
  }

  const username = instagram.trim();

  if (username.includes('@') || username.includes('/') || username.includes(':')) {
    return false;
  }

  const regex = /^[A-Za-z0-9._]{1,30}$/;
  return regex.test(username);
}

export function isValidTime(time: string): boolean {
  return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time);
}

export function isValidUrl(url?: string): boolean {
  if (url) {
    const urlRegex = /^https?:\/\/[^\s/$.?#].[^\s]*\.[a-zA-Z0-9-]+$/;
    try {
      new URL(url);
      return urlRegex.test(url);
    } catch (_) {
      return false;
    }
  }
  return false;
}

export function isValidPassword(password?: string): boolean {
  if (password) {
    /* eslint-disable no-useless-escape */
    const regex = /^(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return regex.test(password);
  }
  return false;
}
  
export function isValidPhone(phone?: string): boolean {
  if (phone) {
    const phoneRegex = /^\+?\d{1,4}[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    return phoneRegex.test(phone);
  }
  return false;
}

export function isFutureDate(date: Date): boolean {
  const now = new Date();
  now.setSeconds(0, 0);

  return date > now;
}

export function isValidText(text: string, min?: number, max?: number): boolean {

  if (text.trim() !== text) {
    return false;
  }

  if (min !== undefined && text.length < min) {
    return false;
  }

  if (max !== undefined && text.length > max) {
    return false;
  }

  return true;
}

export const isDateInFuture = (date: string | Date): boolean => {
  const inputDate = new Date(date);
  const currentDate = new Date();
  
  currentDate.setHours(0, 0, 0, 0);
  
  return inputDate > currentDate;
};
